import { render, staticRenderFns } from "./pealeht.vue?vue&type=template&id=bdad2f78&scoped=true&"
import script from "./pealeht.vue?vue&type=script&lang=js&"
export * from "./pealeht.vue?vue&type=script&lang=js&"
import style0 from "./pealeht.vue?vue&type=style&index=0&id=bdad2f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdad2f78",
  null
  
)

export default component.exports